// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"67b9d28f","317":"34c62431","419":"3e62ce8d","513":"ac16d1d2","703":"7113db9a","734":"e51f26cf","787":"8266cc13","824":"ed72f77d"}[chunkId] + ".chunk.js";
};